import { render, staticRenderFns } from "./SliderRelatives.vue?vue&type=template&id=5d979fc1&"
import script from "./SliderRelatives.vue?vue&type=script&lang=js&"
export * from "./SliderRelatives.vue?vue&type=script&lang=js&"
import style0 from "./SliderRelatives.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports